import request from '@/utils/request'

export function HotspotList(route) {
    return request({
        url: '/hotspot/list',
        method: 'get',
        params: { route }
    })
}

export function HandleHotspot(data) {
    return request({
        url: '/hotspot/handle',
        method: 'post',
        data
    })
}

export function unwrapHotspotList(res) {
    if (Array.isArray(res)) return res
    if (Array.isArray(res?.list)) return res.list
    if (Array.isArray(res?.data)) return res.data
    if (Array.isArray(res?.data?.list)) return res.data.list
    return []
}

export function normalizeHotspot(item) {
    let hotspot = item?.hotspot
    if (typeof hotspot === 'string') {
        try {
            hotspot = JSON.parse(hotspot)
        } catch (error) {
            hotspot = null
        }
    }
    const source = hotspot && typeof hotspot === 'object' ? hotspot : (item || {})
    const productId = Number(source.product_id)
    return {
        id: Number(item?.id ?? item?.ID ?? 0),
        route: item?.route || '',
        hotspot: {
            placement: source.placement || '',
            x: Number(source.x) || 0,
            y: Number(source.y) || 0,
            width: Number(source.width) || 0,
            height: Number(source.height) || 0,
            link_type: source.link_type === 'external' ? 'external' : 'product',
            product_id: productId > 0 ? productId : null,
            url: source.url || '',
            product_name: source.product_name || '',
            anchor_type: source.anchor_type === 'img' || source.anchor_type === 'bg' ? source.anchor_type : '',
            anchor_src: source.anchor_src || '',
            anchor_index: Number(source.anchor_index) || 0,
        }
    }
}
